import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import IconNoData from "~src/components/icons/IconNoData.vue";

const __default__ = {};

interface IProps {
  modifyClass?: string;
  title?: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'NoData',
  props: {
    modifyClass: { default: "" },
    title: { default: "Chưa có dữ liệu" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-no-data ${_ctx.modifyClass}`)
  }, [
    _createVNode(IconNoData),
    _createElementVNode("h4", null, _toDisplayString(_ctx.title), 1)
  ], 2))
}
}

})